
import SearchProductCarousel from "./SearchProductCarousel";
import siteConfig from "~/site.config.json";

export default {
  components: { SearchProductCarousel },

  props: {
    products: { type: Array, required: true },
    suggestion: { type: String, required: true },
    closeSearch: { type: Function, required: true },
    loading: { type: Boolean, required: true },
    isTrendingState: { type: Boolean, default: false },
  },

  data() {
    return {
      sizesForUrl: siteConfig?.sizesForUrl ?? [],
    };
  },

  computed: {
    suggestionText() {
      return this.suggestion.length > 50
        ? `${this.suggestion.substring(0, 50)}...`
        : this.suggestion;
    },
    viewAllURL() {
      const sizes = this.extractSizesFromSuggestion(this.suggestion);

      const query = {
        query: this.suggestion,
        ...(sizes.length > 0 && {
          "filter.option_sizes": sizes,
        }),
      };

      return this.$router.resolve({
        path: "/products/search",
        query,
      }).href;
    },
    swiperClass() {
      return `center-search-products-swiper`;
    },
  },

  methods: {
    extractSizesFromSuggestion(text) {
      if (!text || !this.sizesForUrl.length) return [];

      const lower = text.toLowerCase();

      const detectedSizes = this.sizesForUrl
        .map(size => {
          const index = lower.indexOf(size.toLowerCase());
          return index !== -1 ? { size, index } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.index - b.index);

      // AC2.2: pick the first size as it appears in the query text
      return detectedSizes.length ? [detectedSizes[0].size] : [];
    },
  },
};
